import React from 'react';

import Button from '../../Button/Button';
import './Post.css';

const Post = props => (
  <article className="post">
    <header className="post__header">
      <h1 className="post__title">{props.title}</h1>
      <p>{props.content}</p>
    </header>
    <div className="post__actions">
      <Button mode="flat" onClick={props.onStartEdit}>
        Edit
      </Button>
      <Button mode="flat" design="danger" onClick={props.onDelete}>
        Delete
      </Button>
    </div>
  </article>
);

export default Post;
